import ImageLayer from 'ol/layer/Image'
import { ImageWMS } from 'ol/source'

import { MAP_PROXY_URL, MAP_WMS_URL } from 'widgets/map/config'
import { ILayer } from 'shared/api/user'

export const createImgLyr = (
	layer: ILayer,
	isBase: boolean
): ImageLayer<ImageWMS> => {
	const url = `${window.location.origin}/${
		String(layer.srvSystemId) === '6' &&
		[1, 2, 4, 5].includes(Number(layer.type))
			? MAP_WMS_URL
			: MAP_PROXY_URL + layer.id
	}`

	const paramsLayers =
		String(layer.srvSystemId) === '6' &&
		[1, 2, 4, 5].includes(Number(layer.type))
			? layer.id
			: layer.layerSourceWMS
			? layer.layerSourceWMS.name
			: layer.WMSName

	console.log({ url, layer })

	return new ImageLayer({
		source: new ImageWMS({
			url,
			params: {
				LAYERS: paramsLayers,
				TILED: !!layer.tiled,
				STYLES: layer.defaultStyle,
			},
			ratio: 1,
			serverType: 'geoserver',
			crossOrigin: 'Anonymous',
		}),
		properties: {
			title: layer.name,
			idLayer: layer.id,
			id: layer.id,
			type: isBase ? 'base' : 'overlay',
			autoload: layer.autoload,
			group: layer.LayerGroup,
			classifierFilterRules: layer.classifierFilterRules,
			hideOnSatelliteView: layer.hideOnSatelliteView,
		},
	})
}
